// extracted by mini-css-extract-plugin
export default {"background":"BackgroundOverlay_background__aVJz8"};